import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CountryRiskIndicesService } from '@grid-ui/country-risk/indices';
import { map } from 'rxjs';

@Component({
  selector: 'mc-top-subscription-counter',
  standalone: false,
  templateUrl: './top-subscription-counter.component.html',
  styleUrl: './top-subscription-counter.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TopSubscriptionCounterComponent {
  private readonly indexService = inject(CountryRiskIndicesService);
  public readonly shareSrc = `assets/img/icons/share.svg`;

  public readonly subscriptionCountText = signal<string | undefined>(undefined);

  constructor() {
    this.indexService
      .getRiskIndices({ show_restricted: 1 })
      .pipe(
        takeUntilDestroyed(),
        map((indices) => {
          const totalIndices = indices.length;
          const subscribedIndices = indices.filter((item) => !item.restricted).length;

          return `${subscribedIndices}/${totalIndices} indices`;
        }),
      )
      .subscribe((text) => this.subscriptionCountText.set(text));
  }
}
